export default __webpack_public_path__ + "static/media/499.c57c2298.jpg";